export default __webpack_public_path__ + "static/media/coe_logo.b293ff2c.png";